import { gql } from "@apollo/client";

export const WEATHER = gql`
    query BoardingPass($code_in: [String]) {
        weather(where: {code: {code_in: $code_in}}) {
            name
            icon {
                paths
            }
        }
    }  
`
